export default __webpack_public_path__ + "static/media/SIFA_EPILOGFIN1.e4032f92.mp3";